module.exports = __webpack_public_path__ + "static/kampanya-duyuru-de6e3c51c8d15cdca2f518406956e39e.webp";